import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Units } from '../service/units.js';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../contact-us/contact-us.service';
import Swal from 'sweetalert2';

@Component ({
    selector: 'app-allegria',
    templateUrl: './allegria.component.html',
    styleUrls: ['./allegria.component.scss'],
    standalone: false
})
export class AllegriaComponent implements OnInit {
  units = Units;
  updateForm: UntypedFormGroup;
  submitted: boolean;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    nav: false,
    navText: ['◀', '▶'],
    items: 1,
  };

  constructor(
      private builder: UntypedFormBuilder,
      private contactService: ContactUsService) {
  }

  ngOnInit(): void {
    this.initForm ();
  }

  initForm(): void {
    this.updateForm = this.builder.group (
        {
          phone: ['', Validators.required],
          name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          notes: ['', [Validators.required, Validators.minLength (20)]]
        },
        onblur
    );
  }

  isFieldValid(field: string): boolean {
    return (
        !this.updateForm.get (field).valid && this.updateForm.get (field).touched
    );
  }

  onSubmit(): void {
    if ( this.updateForm.valid ) {
      this.submitted = true;
      const popup = {
        title: 'Your inquiry has been sent successfully',
        text: 'We will contact you as soon as possible',
        button: 'Done',
      };

      this.contactService.sendMail (this.updateForm.value).subscribe (
          (res) => {
            Swal.fire ({
              title: popup.title,
              text: popup.text,
              icon: 'success',
              confirmButtonText: popup.button,
            }).then (() => {
              this.submitted = false;
              this.updateForm.reset ();
            });
          },
          (err) => {
            console.log (err);
            this.submitted = false;
          }
      );
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView ({behavior: 'smooth'});
  }
}
